import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FooterComponent } from './footer.component';
import { MatButtonModule } from '@angular/material/button';
import { ContainerModule } from '../../directives/container/container.module';
import 'iconify-icon';

@NgModule({
  imports: [
    CommonModule,
    MatButtonModule,
    ContainerModule
  ],
  declarations: [FooterComponent],
  exports: [FooterComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA] // 👈 Add this line
})
export class FooterModule {
}
